<template>
  <div class="top">
    <div class="block">
      <el-form :model="formData" label-width="200px" :label-position="'right'">
        <el-form-item label="类型">
          <el-select v-model="formData.machineType" placeholder="请选择类型">
            <el-option v-for="item in machineTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源交易所">
          <el-select v-model="formData.exchangeSrc" placeholder="请选择交易所">
            <el-option v-for="item in exchangeSrcEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="TOKEN ID或目标币或指数价" v-if="isShow">
          <el-input v-model="formData.config" placeholder="请输入TOKEN ID或目标币或指数价" required="required" clearable style="width: 500px"></el-input>
        </el-form-item>

        <el-form-item label="用户ID">
          <el-input v-model="formData.userId" placeholder="请输入用户ID" required="required" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="交易对">
          <el-input v-model="formData.pair" placeholder="请输入交易对" required="required" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item  label="行情同步开关">
          <el-radio-group v-model="formData.enabledFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  label="成交刷量开关">
          <el-radio-group v-model="formData.dealFlag">
            <el-radio class="radio" label="1">是</el-radio>
            <el-radio class="radio" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价差比例阈值">
          <el-input v-model="formData.thresholdStopProcessDepth" placeholder="请输入价差比例阈值" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="成交量缩放">
          <el-input v-model="formData.dealAmtPercentage" placeholder="请输入成交量缩放" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买baseAmt">
          <el-input v-model="formData.bidBaseAmt" placeholder="请输入买baseAmt" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖baseAmt">
          <el-input v-model="formData.askBaseAmt" placeholder="请输入卖baseAmt" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买密度">
          <el-input v-model="formData.bidPriceDensity" placeholder="请输入买密度" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖密度">
          <el-input v-model="formData.askPriceDensity" placeholder="请输入卖密度" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买一撤回">
          <el-input v-model="formData.bidFirstPlaceDiscounted" placeholder="请输入买一撤回" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖一撤回">
          <el-input v-model="formData.askFirstPlaceDiscounted" placeholder="请输入卖一撤回" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买方向委托量缩小档位">
          <el-input v-model="formData.bidPositionReduce" placeholder="请输入买方向委托量缩小档位" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖方向委托量缩小档位">
          <el-input v-model="formData.askPositionReduce" placeholder="请输入卖方向委托量缩小档位" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买方向档位固定金额">
          <el-input v-model="formData.bidPositionAmount" placeholder="请输入买方向档位固定金额" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖方向档位固定金额">
          <el-input v-model="formData.askPositionAmount" placeholder="请输入卖方向档位固定金额" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="买吃单价差">
          <el-input v-model="formData.bidTradePriceRate" placeholder="请输入买吃单价差" aria-required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="卖吃单价差">
          <el-input v-model="formData.askTradePriceRate" placeholder="请输入卖吃单价差" aria-required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="时间间隔（秒）">
          <el-input v-model="formData.intervalMs" placeholder="请输入时间间隔" required="required" type="number" clearable style="width: 400px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="目标交易所">
          <el-input v-model="formData.exchangeTarget" placeholder="请输入目标交易所" required="required" clearable style="width: 400px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="币对等级">
          <el-radio-group v-model="formData.coinLevel">
            <el-radio class="radio" label="1">1</el-radio>
            <el-radio class="radio" label="2">2</el-radio>
            <el-radio class="radio" label="3">3</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  label="指数价手动偏移开关">
          <el-radio-group v-model="formData.priceManualDeviateFlag">
            <el-radio class="radio" label="true">是</el-radio>
            <el-radio class="radio" label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指数价手动偏移比例" v-if="formData.priceManualDeviateFlag === 'true'">
          <el-input v-model="formData.priceManualDeviateRatio" placeholder="请输入指数价手动偏移比例（向上为正，向下为负）" required="required" type="number" clearable style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item  label="动态买卖回撤开关">
          <el-radio-group v-model="formData.priceAutoDeviateFlag">
            <el-radio class="radio" label="true">是</el-radio>
            <el-radio class="radio" label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row>
          <el-col :span="8">
            <el-form-item label="动态买卖回撤偏移量" v-if="formData.priceAutoDeviateFlag === 'true'">
              <el-input v-model="formData.priceAutoDeviateAmt" placeholder="指数价自动偏移量" required="required" type="number" clearable style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="动态买卖回撤偏移比例" v-if="formData.priceAutoDeviateFlag === 'true'">
              <el-input v-model="formData.priceAutoDeviateRatio" placeholder="指数价自动偏移比例" required="required" type="number" clearable style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="动态买卖回撤最大比例" v-if="formData.priceAutoDeviateFlag === 'true'">
              <el-input v-model="formData.priceAutoDeviateMaxRate" placeholder="动态回撤最大比例" required="required" type="number" clearable style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item  label="自定义盘口配置开关">
          <el-radio-group v-model="formData.customPositionFlag">
            <el-radio class="radio" label="true">是</el-radio>
            <el-radio class="radio" label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidLowPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidLowPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askLowPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askLowPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidLowMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidLowMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askLowMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askLowMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidLowMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidLowMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askLowMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askLowMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘低档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidLowOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidLowOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘低档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askLowOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askLowOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.customPositionFlag === 'true'">
          <el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col>
        </el-row>
        <br v-if="formData.customPositionFlag === 'true'">
        <br v-if="formData.customPositionFlag === 'true'">

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidMediumPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidMediumPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askMediumPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askMediumPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidMediumMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidMediumMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askMediumMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askMediumMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidMediumMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidMediumMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askMediumMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askMediumMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘中档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidMediumOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidMediumOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘中档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askMediumOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askMediumOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.customPositionFlag === 'true'">
          <el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col>
        </el-row>
        <br v-if="formData.customPositionFlag === 'true'">
        <br v-if="formData.customPositionFlag === 'true'">

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidHighPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidHighPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位区间" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askHighPlaceRegionLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askHighPlaceRegionUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidHighMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidHighMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位大部分概率" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askHighMajorProbabilityLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askHighMajorProbabilityUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidHighMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidHighMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位大部分倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askHighMajorMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askHighMajorMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="买盘高档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.bidHighOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.bidHighOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卖盘高档位其余倍数" v-if="formData.customPositionFlag === 'true'">
              <el-input v-model="formData.askHighOtherMultipleLower" required="required" type="number" clearable style="width: 180px"></el-input>
              <span> - </span>
              <el-input v-model="formData.askHighOtherMultipleUpper" required="required" type="number" clearable style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit">新增</el-button>
          <el-button @click="clearData">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from './api'

const machineTypeOp = [
  {key:'SYNC_INDEX_PRICE', label: '外部同步指数价'},
  {key:'SYNC_DEPTH_AND_DEAL', label:'外部同步行情和成交'},
]
const exchangeSrcOp = [
  {key:'BINANCE', label: '币安'},
  {key:'HUOBI', label:'火币'},
  {key:'OKEX', label:'OKEX'},
  {key:'FTX', label:'FTX'},
  {key:'COINEX', label:'COINEX'},
  {key:'ZB', label:'ZB'},
  {key:'MXC', label:'MXC'},
  {key:'GATEIO', label: 'GATEIO'},
  {key:'BIKI', label:'BIKI'},
  {key:'BITMART', label:'BITMART'},
  {key:'KUCOIN', label:'KUCOIN'},
  {key:'LBANK', label:'LBANK'},
]
const exchangeSrcOp1 = [
  {key:'UNISWAP', label:'UNISWAP'},
  {key:'PANCAKE', label:'PANCAKE'},
  {key:'BAKERY', label:'BAKERY'},
  {key:'FIXED_ETH', label:'固定锚定以太坊'},
  {key:'FUND', label:'平台基金'},
  {key:'MDEX', label:'MDEX'},
  {key:'PANGOLIN', label:'PANGOLIN'},
  {key:'SPOOKYSWAP', label:'SPOOKYSWAP'},
  {key:'SHIBASWAP', label:'SHIBASWAP'},
  {key:'JOE', label:'JOE'},
  {key:'SUSHI', label:'SUSHI'},
  {key:'RAYDIUM', label:'RAYDIUM'},
  {key:'QUICKSWAP', label:'QUICKSWAP'},
  {key:'FIXED_USDT', label:'固定锚定内部价'},
  {key:'CUSTOM_PRICE', label:' 自定义指数价'}
]
const priceManualDeviateFlagOp = [
  {key:true, label:'是'},
  {key:false, label:'否'},
]


export default {
  name: "AddQuotation",

  data(){
    return{
      isShow:false,
      customPosition:{
        "bidLowPlaceRegion":"买盘低档位区间",
        "bidLowMajorProbability":"买盘低档位大部分概率",
        "bidLowMajorMultiple":"买盘低档位大部分倍数",
        "bidLowOtherMultiple":"买盘低档位其余倍数",
        "askLowPlaceRegion":"卖盘低档位区间",
        "askLowMajorProbability":"卖盘低档位大部分概率",
        "askLowMajorMultiple":"卖盘低档位大部分倍数",
        "askLowOtherMultiple":"卖盘低档位其余倍数",

        "bidMediumPlaceRegion":"买盘中档位区间",
        "bidMediumMajorProbability":"买盘中档位大部分概率",
        "bidMediumMajorMultiple":"买盘中档位大部分倍数",
        "bidMediumOtherMultiple":"买盘中档位其余倍数",
        "askMediumPlaceRegion":"卖盘中档位区间",
        "askMediumMajorProbability":"卖盘中档位大部分概率",
        "askMediumMajorMultiple":"卖盘中档位大部分倍数",
        "askMediumOtherMultiple":"卖盘中档位其余倍数",

        "bidHighPlaceRegion":"买盘高档位区间",
        "bidHighMajorProbability":"买盘高档位大部分概率",
        "bidHighMajorMultiple":"买盘高档位大部分倍数",
        "bidHighOtherMultiple":"买盘高档位其余倍数",
        "askHighPlaceRegion":"卖盘高档位区间",
        "askHighMajorProbability":"卖盘高档位大部分概率",
        "askHighMajorMultiple":"卖盘高档位大部分倍数",
        "askHighOtherMultiple":"卖盘高档位其余倍数",
      },
      formData:{
        pair:'',
        userId:'',
        config:'',
        enabledFlag:"1",
        dealFlag:"1",
        thresholdStopProcessDepth:'',
        dealAmtPercentage:'',
        bidBaseAmt:'',
        askBaseAmt:'',
        bidPriceDensity:'',
        askPriceDensity:'',
        bidFirstPlaceDiscounted:'',
        askFirstPlaceDiscounted:'',
        bidPositionReduce:'',
        askPositionReduce:'',
        bidPositionAmount:'',
        askPositionAmount:'',
        coinLevel:'2',
        exchangeSrc:'',
        machineType:'',
        priceManualDeviateFlag:"false",
        priceManualDeviateRatio:0,
        priceAutoDeviateFlag:"false",
        priceAutoDeviateAmt:0,
        priceAutoDeviateRatio:0,
        priceAutoDeviateMaxRate:0.02,
        exchangeTarget:'INTERNAL',
        bidTradePriceRate: '',
        askTradePriceRate: '',
        intervalMs:-1,

        customPositionFlag:"false",
        bidLowPlaceRegion:'',
        bidLowPlaceRegionLower:1,
        bidLowPlaceRegionUpper:5,
        bidLowMajorProbability:'',
        bidLowMajorProbabilityLower:1,
        bidLowMajorProbabilityUpper:5,
        bidLowMajorMultiple:'',
        bidLowMajorMultipleLower:5,
        bidLowMajorMultipleUpper:10,
        bidLowOtherMultiple:'',
        bidLowOtherMultipleLower:3,
        bidLowOtherMultipleUpper:5,
        bidMediumPlaceRegion:'',
        bidMediumPlaceRegionLower:6,
        bidMediumPlaceRegionUpper:15,
        bidMediumMajorProbability:'',
        bidMediumMajorProbabilityLower:1,
        bidMediumMajorProbabilityUpper:10,
        bidMediumMajorMultiple:'',
        bidMediumMajorMultipleLower:5,
        bidMediumMajorMultipleUpper:10,
        bidMediumOtherMultiple:'',
        bidMediumOtherMultipleLower:3,
        bidMediumOtherMultipleUpper:5,
        bidHighPlaceRegion:'',
        bidHighPlaceRegionLower:16,
        bidHighPlaceRegionUpper:100,
        bidHighMajorProbability:'',
        bidHighMajorProbabilityLower:1,
        bidHighMajorProbabilityUpper:3,
        bidHighMajorMultiple:'',
        bidHighMajorMultipleLower:5,
        bidHighMajorMultipleUpper:10,
        bidHighOtherMultiple:'',
        bidHighOtherMultipleLower:3,
        bidHighOtherMultipleUpper:5,
        askLowPlaceRegion:'',
        askLowPlaceRegionLower:1,
        askLowPlaceRegionUpper:5,
        askLowMajorProbability:'',
        askLowMajorProbabilityLower:1,
        askLowMajorProbabilityUpper:5,
        askLowMajorMultiple:'',
        askLowMajorMultipleLower:5,
        askLowMajorMultipleUpper:10,
        askLowOtherMultiple:'',
        askLowOtherMultipleLower:3,
        askLowOtherMultipleUpper:5,
        askMediumPlaceRegion:'',
        askMediumPlaceRegionLower:6,
        askMediumPlaceRegionUpper:15,
        askMediumMajorProbability:'',
        askMediumMajorProbabilityLower:1,
        askMediumMajorProbabilityUpper:10,
        askMediumMajorMultiple:'',
        askMediumMajorMultipleLower:5,
        askMediumMajorMultipleUpper:10,
        askMediumOtherMultiple:'',
        askMediumOtherMultipleLower:3,
        askMediumOtherMultipleUpper:5,
        askHighPlaceRegion:'',
        askHighPlaceRegionLower:16,
        askHighPlaceRegionUpper:100,
        askHighMajorProbability:'',
        askHighMajorProbabilityLower:1,
        askHighMajorProbabilityUpper:3,
        askHighMajorMultiple:'',
        askHighMajorMultipleLower:5,
        askHighMajorMultipleUpper:10,
        askHighOtherMultiple:'',
        askHighOtherMultipleLower:3,
        askHighOtherMultipleUpper:5,
      },
      exchangeSrcEnum: [],
      machineTypeEnum: machineTypeOp
    }
  },
  watch:{
    'formData.exchangeSrc'(val){
      if (val === 'UNISWAP'
          || val=== 'MDEX'
          || val === 'FIXED_USDT'
          || val === 'CUSTOM_PRICE'
          || val === 'PANCAKE'
          || val === 'BAKERY'
          || val === 'PANGOLIN'
          || val === 'SPOOKYSWAP'
          || val === 'SHIBASWAP'
          || val === 'JOE'
          || val === 'SUSHI'
          || val === 'RAYDIUM'
          || val === 'QUICKSWAP'
    ){
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    'formData.machineType'(val){
      if (val === 'SYNC_INDEX_PRICE'){
        this.formData.exchangeSrc = 'UNISWAP'
        this.exchangeSrcEnum = exchangeSrcOp1
      }else{
        this.formData.exchangeSrc = ''
        this.exchangeSrcEnum = exchangeSrcOp
      }
    }
  },
  methods:{
    buildParamsBeforeRequest(formData){
      for (let key in formData){
        if (this.customPosition.hasOwnProperty(key)){
          let lower = key + "Lower";
          let upper = key + "Upper";
          if (parseFloat(formData[lower]) > parseFloat(formData[upper])){
            let msg = this.customPosition[key] + ',参数错误,区间最小值大于区间最大值';
            this.$message.error(msg)
            formData.validate = false
            return formData;
          }
          formData[key] = formData[lower] + "," + formData[upper]
        }
      }
      return formData
    },

    submit(){
      this.formData.validate = ''
      if(this.formData.pair === ''){ this.$message.error('交易对不能为空')
        return
      }
      if(this.formData.userId === ''){ this.$message.error("用户ID不能为空")
        return
      }
      if(this.formData.thresholdStopProcessDepth === ''){ this.$message.error("价差比例阈值不能为空")
        return
      }
      if (this.formData.dealAmtPercentage === ''){ this.$message.error("成交量缩放不能为空")
        return
      }
      if (this.formData.bidBaseAmt === ''){ this.$message.error("买baseAmt不能为空")
        return
      }
      if (this.formData.askBaseAmt === ''){ this.$message.error("卖baseAmt不能为空")
        return
      }
      if (this.formData.bidPriceDensity === ''){ this.$message.error("买密度不能为空")
        return
      }
      if (this.formData.askPriceDensity === ''){ this.$message.error("卖密度不能为空")
        return
      }
      if (this.formData.bidFirstPlaceDiscounted === ''){this.$message.error('买一撤回不能为空')
        return
      }
      if (this.formData.askFirstPlaceDiscounted === ''){ this.$message.error('卖一撤回不能为空')
        return
      }
      if (this.formData.bidPositionReduce === ''){ this.$message.error('买方向委托量缩小档位不能为空')
        return
      }
      if (this.formData.askPositionReduce === ''){ this.$message.error('卖方向委托量缩小档位不能为空')
        return
      }
      if (this.formData.bidPositionAmount === ''){ this.$message.error('买方向档位固定金额不能为空')
        return
      }
      if (this.formData.askPositionAmount === ''){ this.$message.error('卖方向档位固定金额不能为空')
        return
      }
      if (this.formData.bidTradePriceRate === ''){ this.$message.error('买吃单价差不能为空')
        return
      }
      if (this.formData.askTradePriceRate === ''){ this.$message.error('卖吃单价差不能为空')
        return
      }
      if (this.formData.priceManualDeviateRatio === ''){ this.$message.error('指数价手动偏移比例')
        return
      }
      if (this.formData.priceAutoDeviateAmt === ''){ this.$message.error('指数价自动偏移量')
        return
      }
      if (this.formData.priceAutoDeviateRatio === ''){ this.$message.error('指数价自动偏移比例')
        return
      }
      if (this.formData.priceAutoDeviateMaxRate === ''){ this.$message.error('动态回撤最大比例')
        return
      }
      this.formData = this.buildParamsBeforeRequest(this.formData)
      if (this.formData.validate === false) { return }
      api.savePairDepthDealConfig(this.formData).then((response)=>{
        if (response.data === true){
          this.$message.success("添加成功")
        }else{
          this.$message.error("添加失败")
        }
      })
    },
    clearData(){
      return {
        pair:'',
        userId:'',
        config:'',
        thresholdStopProcessDepth:'',
        dealAmtPercentage:'',
        bidBaseAmt:'',
        askBaseAmt:'',
        bidPriceDensity:'',
        askPriceDensity:'',
        bidFirstPlaceDiscounted:'',
        askFirstPlaceDiscounted:'',
        bidPositionReduce:'',
        askPositionReduce:'',
        bidPositionAmount:'',
        askPositionAmount:'',
        coinLevel:'2',
        exchangeSrc:'',
        machineType:'',
        priceManualDeviateFlag:"false",
        priceManualDeviateRatio:0,
        priceAutoDeviateFlag:"false",
        priceAutoDeviateAmt:0,
        priceAutoDeviateRatio:0,
        priceAutoDeviateMaxRate:0.02,
        exchangeTarget:'INTERNAL',
        intervalMs:-1,
        customPositionFlag:"false",
        bidLowPlaceRegion:'',
        bidLowPlaceRegionLower:1,
        bidLowPlaceRegionUpper:5,
        bidLowMajorProbability:'',
        bidLowMajorProbabilityLower:1,
        bidLowMajorProbabilityUpper:5,
        bidLowMajorMultiple:'',
        bidLowMajorMultipleLower:5,
        bidLowMajorMultipleUpper:10,
        bidLowOtherMultiple:'',
        bidLowOtherMultipleLower:3,
        bidLowOtherMultipleUpper:5,
        bidMediumPlaceRegion:'',
        bidMediumPlaceRegionLower:6,
        bidMediumPlaceRegionUpper:15,
        bidMediumMajorProbability:'',
        bidMediumMajorProbabilityLower:1,
        bidMediumMajorProbabilityUpper:10,
        bidMediumMajorMultiple:'',
        bidMediumMajorMultipleLower:5,
        bidMediumMajorMultipleUpper:10,
        bidMediumOtherMultiple:'',
        bidMediumOtherMultipleLower:3,
        bidMediumOtherMultipleUpper:5,
        bidHighPlaceRegion:'',
        bidHighPlaceRegionLower:16,
        bidHighPlaceRegionUpper:100,
        bidHighMajorProbability:'',
        bidHighMajorProbabilityLower:1,
        bidHighMajorProbabilityUpper:3,
        bidHighMajorMultiple:'',
        bidHighMajorMultipleLower:5,
        bidHighMajorMultipleUpper:10,
        bidHighOtherMultiple:'',
        bidHighOtherMultipleLower:3,
        bidHighOtherMultipleUpper:5,
        askLowPlaceRegion:'',
        askLowPlaceRegionLower:1,
        askLowPlaceRegionUpper:5,
        askLowMajorProbability:'',
        askLowMajorProbabilityLower:1,
        askLowMajorProbabilityUpper:5,
        askLowMajorMultiple:'',
        askLowMajorMultipleLower:5,
        askLowMajorMultipleUpper:10,
        askLowOtherMultiple:'',
        askLowOtherMultipleLower:3,
        askLowOtherMultipleUpper:5,
        askMediumPlaceRegion:'',
        askMediumPlaceRegionLower:6,
        askMediumPlaceRegionUpper:15,
        askMediumMajorProbability:'',
        askMediumMajorProbabilityLower:1,
        askMediumMajorProbabilityUpper:10,
        askMediumMajorMultiple:'',
        askMediumMajorMultipleLower:5,
        askMediumMajorMultipleUpper:10,
        askMediumOtherMultiple:'',
        askMediumOtherMultipleLower:3,
        askMediumOtherMultipleUpper:5,
        askHighPlaceRegion:'',
        askHighPlaceRegionLower:16,
        askHighPlaceRegionUpper:100,
        askHighMajorProbability:'',
        askHighMajorProbabilityLower:1,
        askHighMajorProbabilityUpper:3,
        askHighMajorMultiple:'',
        askHighMajorMultipleLower:5,
        askHighMajorMultipleUpper:10,
        askHighOtherMultiple:'',
        askHighOtherMultipleLower:3,
        askHighOtherMultipleUpper:5,
      }
    }
  }
}
</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 40px 30px 10px 30px;
  height: auto;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>